/**
 * Home page wrapper that decides whether to show login or home layout.
 * 決定顯示登入頁或首頁佈局的首頁組件。
 */
import { useSelector } from "react-redux";
import HomeLayout from '@/features/home/components/HomeLayout';
import Login from '@/features/auth/pages/LandingPage';

function Home() {
    const token = useSelector((state) => state.user.token);
    const idolId = useSelector((state) => state.user.idolId);

    // Redirect to login page when missing credentials
    // 當沒有登入憑證時導向登入頁面
    if (!token || !idolId) {
        return <Login />;
    }

    return (
        <HomeLayout
            idolId={idolId}
        />
    );
}

export default Home;
